var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 18H17.25V21H14.25V18ZM19.5 18H22.5V21H19.5V18ZM14.25 12.75H17.25V15.75H14.25V12.75ZM19.5 12.75H22.5V15.75H19.5V12.75Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 18H3V7.5H21V11.25H22.5V7.5C22.4996 7.1023 22.3414 6.721 22.0602 6.43978C21.779 6.15856 21.3977 6.0004 21 6H16.5V3C16.4996 2.6023 16.3414 2.221 16.0602 1.93978C15.779 1.65856 15.3977 1.5004 15 1.5H9C8.6023 1.5004 8.221 1.65856 7.93978 1.93978C7.65856 2.221 7.5004 2.6023 7.5 3V6H3C2.6023 6.0004 2.221 6.15856 1.93978 6.43978C1.65856 6.721 1.5004 7.1023 1.5 7.5V18C1.5004 18.3977 1.65856 18.779 1.93978 19.0602C2.221 19.3414 2.6023 19.4996 3 19.5H12.75V18ZM9 3H15V6H9V3Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.f2a6f6953c9019257e5be560b61ff348.svg";
export { ForwardRef as ReactComponent };